export const renderAttribute = (
  show: string[] | undefined,
  key: string,
  value: any,
  unit?: string,
  isTitle?: boolean,
  isBig?: boolean
) => {
  if (!show?.includes(key) || !value) return null;
  return (
    <div
      className={`font-bold mt-2 ${isTitle ? `!text-lg font-bold text-gray-700 leading-tight line-clamp-2 ${isBig ? "!text-3xl" : ""}` : "text-sm"}`}
    >
      {value} {unit}
    </div>
  );
};
